export default (state, action) => {
  const { data, key } = action;
  return {
    ...state,
    [key]: data,
  };
};
